import * as jobTempleteActions from "./actions"

import { all, call, put, takeEvery } from "redux-saga/effects"
import {
  createJobTemplate,
  deleteJobTemplate,
  getAllJobTemplates,
  updateJobTemplate,
  getJobTemplateById
} from "@src/services/apis"

import { JOB_TEMPLETE_TYPES } from "./types"
import toast from "react-hot-toast"


function* getAllJobTempletesRequest(action) {
  try {
    const response = yield call(getAllJobTemplates, action.payload)
    yield put(jobTempleteActions.getAllJobTempleteesSuccess(response.data))
  } catch (err) {
    yield put(jobTempleteActions.getAllJobTempleteesSuccess(err))
  }
}

function* createJobTempleteRequest(action) {
  try {
    const response = yield call(createJobTemplate, action.payload)
    if (response?.status === 201) {
      yield put(jobTempleteActions.createJobTempleteSuccess(response.data))
      toast.success("Job template created successfully")
    } else {
      yield put(jobTempleteActions.createJobTempleteFailure(response.data))
      toast.error("Job template creation failed")
    }
  } catch (err) {
    yield put(jobTempleteActions.createJobTempleteFailure(err))
  }
}

function* updateJobTempleteRequest(action) {
  try {
    const response = yield call(updateJobTemplate, action.payload)
    if (response?.status === 200) {
      yield put(jobTempleteActions.updateJobTempleteSuccess(response.data))
      toast.success("Job template updated successfully")
    } else {
      yield put(jobTempleteActions.updateJobTempleteFailure(response.data))
      toast.error("Job template update failed")
    }
  } catch (err) {
    yield put(jobTempleteActions.updateJobTempleteFailure(err))
    toast.error("Job template update failed")
  }
}

function* deleteJobTempleteRequest(action) {
  try {
    const response = yield call(deleteJobTemplate, action.payload)
    yield put(
      jobTempleteActions.deleteJobTempleteSuccess(response?.remaining_calls)
    )
  } catch (err) {
    yield put(jobTempleteActions.deleteJobTempleteFailure(err))
  }
}

function* getSpecificJobTempletesRequest(action) {
  try {
    const response = yield call(getJobTemplateById, action.payload)
    yield put(jobTempleteActions.getSpecificJobTempleteSuccess(response.data))
  } catch (err) {
    yield put(jobTempleteActions.getSpecificJobTempleteFailure(err))
  }
}

export default function* jobTempleteSaga() {
  yield all([
    takeEvery(
      JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_REQUEST,
      getAllJobTempletesRequest
    ),
    takeEvery(
      JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_REQUEST,
      getSpecificJobTempletesRequest
    ),
    takeEvery(
      JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_REQUEST,
      createJobTempleteRequest
    ),
    takeEvery(
      JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_REQUEST,
      updateJobTempleteRequest
    ),
    takeEvery(
      JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_REQUEST,
      deleteJobTempleteRequest
    )
  ])
}
